import React from 'react';
import { useIntl } from 'react-intl';

import { SEO as CoreSEO, useSiteMetadata } from 'gatsby-theme-thepuzzlers-core';
import { useLocation } from '@gatsbyjs/reach-router';
import { useIntlContext } from '../utils/context/intl-context';

import revertPathToDefaultLocale from '../utils/revertPathToDefaultLocale';
import { localizePath } from '../utils/localizePath';

export function SEO(props) {
  const location = useLocation();
  const intlConfig = useIntlContext();
  const { locale } = useIntl();
  const siteMetadata = useSiteMetadata();

  const { locales } = intlConfig;
  const defaultLang = locales?.default;
  const { translations = [] } = locales;

  const cleanedPathname = revertPathToDefaultLocale(
    location.pathname,
    intlConfig
  );

  const translatedLinks = translations.map(({ hreflang }) => ({
    rel: 'alternate',
    hreflang: hreflang,
    href: siteMetadata.url + localizePath(cleanedPathname, hreflang, intlConfig)
  }));

  return (
    <CoreSEO
      {...props}
      lang={locale}
      // Adds links for non default locales
      link={[
        {
          rel: 'alternate',
          hreflang: defaultLang,
          href:
            siteMetadata.url +
            localizePath(cleanedPathname, defaultLang, intlConfig)
        },
        {
          rel: 'alternate',
          hreflang: 'x-default',
          href:
            siteMetadata.url +
            localizePath(cleanedPathname, defaultLang, intlConfig)
        }
      ].concat(translatedLinks)}
    />
  );
}
